"use client";

import React, { useState } from "react";
import { MapPin, Phone, Mail, Navigation, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MapAndLocation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [activePin, setActivePin] = useState<string | null>(null);
  const phone = "0412 922 689";
  const email = "cleaningwithgoldstar@gmail.com";
  const serviceArea = "Newcastle, Central Coast, and Sydney";
  const locations = [{
    id: "newcastle",
    name: "Newcastle",
    top: "25%",
    left: "55%"
  }, {
    id: "central-coast",
    name: "Central Coast",
    top: "45%",
    left: "50%"
  }, {
    id: "sydney",
    name: "Sydney",
    top: "70%",
    left: "45%"
  }];
  return <section id="map-and-location" ref={ref} className={cn("dark bg-background text-foreground relative w-full flex flex-col overflow-hidden border-t border-border", isVisible ? "opacity-100" : "opacity-0 transition-opacity duration-1000")}>
      {}
      <div className="relative w-full h-[500px] md:h-[600px] bg-secondary/20 overflow-hidden group">
        {}
        <div className="absolute inset-0 bg-neutral-900">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568801/img/map_dark_grayscale_gold.png" alt="Service Area Map" className="w-full h-full object-cover opacity-40 grayscale contrast-125 mix-blend-overlay transition-transform duration-[10s] ease-linear group-hover:scale-105" />
          {}
          <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-transparent to-background/90 pointer-events-none" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.6)_100%)] pointer-events-none" />
        </div>

        {}
        <div className="absolute inset-0 z-10">
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute transform -translate-x-1/2 -translate-y-1/2 cursor-pointer group/pin" style={{
          top: loc.top,
          left: loc.left
        }} onMouseEnter={() => setActivePin(loc.id)} onMouseLeave={() => setActivePin(null)}>
              {}
              <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping opacity-75 w-12 h-12 -ml-3 -mt-3" />
              
              {}
              <div className="relative z-20 bg-background border-2 border-primary text-primary p-2 rounded-full shadow-[0_0_15px_rgba(234,179,8,0.4)] transition-transform duration-300 hover:scale-110 hover:bg-primary hover:text-primary-foreground">
                <MapPin className="w-6 h-6" />
              </div>

              {}
              <div className={cn("absolute left-1/2 -translate-x-1/2 mt-4 px-4 py-2 bg-card/95 backdrop-blur-md border border-border rounded-lg shadow-xl whitespace-nowrap transition-all duration-300 z-30", activePin === loc.id || i === 1 ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none")}>
                <span className="text-sm font-medium text-foreground tracking-wide">
                  {loc.name}
                </span>
                <div className="absolute -top-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-card border-t border-l border-border transform rotate-45" />
              </div>
            </div>)}
        </div>

        {}
        <div className="hidden md:flex absolute top-8 right-8 z-20 bg-card/80 backdrop-blur-md border border-border/50 p-4 rounded-xl shadow-2xl max-w-xs">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-primary/10 rounded-lg text-primary shrink-0">
              <Navigation className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-1">
                Service Coverage
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed">
                Proudly serving commercial clients across {serviceArea}.
              </p>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="relative z-30 bg-card border-t border-border shadow-[0_-10px_40px_rgba(0,0,0,0.2)]">
        <div className="container mx-auto px-4 py-8 md:py-10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            
            {}
            <div className="text-center md:text-left space-y-2 max-w-xl">
              <h2 className="text-2xl md:text-3xl font-serif text-foreground">
                Ready to get started?
              </h2>
              <p className="text-muted-foreground">
                Our team is ready to assist you across {serviceArea}.
              </p>
            </div>

            {}
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 font-medium h-14 px-8 text-base shadow-lg shadow-primary/20">
                <Link to={`tel:${phone.replace(/\s/g, "")}`}>
                  <Phone className="w-5 h-5 mr-2" />
                  Call {phone}
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary/30 text-foreground hover:bg-primary/5 hover:border-primary/60 h-14 px-8 text-base">
                <Link to={`mailto:${email}`}>
                  <Mail className="w-5 h-5 mr-2 text-primary" />
                  Email Us
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="mt-8 pt-6 border-t border-border md:hidden">
            <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground uppercase tracking-widest">
              <Info className="w-3 h-3 text-primary" />
              <span>Servicing Newcastle • Central Coast • Sydney</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}